<script>
	import { addMinutes, isWithinInterval } from "date-fns";
	import { getContext } from "svelte";
	import { getEventStyles } from "@xbs/lib-scheduler";

	export let event;
	export let calendars = [];
	export let week;
	export let selected;
	$: eventData = event.eventData;
	$: calendar = calendars.find(c => c.id === eventData.type);
	const config = getContext("shedulerConfig");
	const tempaltes = getContext("schedulerTemplates");
	$: ({ dragResize, readonly } = $config);
	$: ({ start_date, end_date } = week);
	$: showResizer =
		!readonly &&
		!eventData.readonly &&
		dragResize &&
		eventData.dragResize &&
		isWithinInterval(addMinutes(eventData.end_date, -1), {
			start: start_date,
			end: end_date,
		});

	$: drag = eventData.dragMove && !eventData.readonly ? "source" : null;

</script>

<div
	class="wx-event-calendar-event {readonly || eventData.readonly ? 'wx-event-calendar-readonly' : ''}"
	class:wx-event-calendar-selected={$selected?.id === eventData.id}
	use:getEventStyles={{ event, backgroundFactor: 'background', calendars }}
	data-id={eventData.id}
	data-drag={drag}>
	<svelte:component
		this={tempaltes.multievent}
		event={eventData}
		{calendar} />
	{#if showResizer}
		<i
			data-drag="source"
			class="wx-event-calendar-resizer wxi-dots-v"
			data-resizer={eventData.id} />
	{/if}
</div>

<style>
	.wx-event-calendar-event {
		position: absolute;
		padding: 0 6px;
		border: 1px solid var(--wx-border-color);
		border-radius: 3px;
		color: var(--wx-color-primary-font);
		background-color: var(--wx-background);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.wx-event-calendar-readonly {
		cursor: default;
	}

	.wx-event-calendar-resizer {
		display: flex;
		justify-content: center;
		flex-shrink: 0;
		position: absolute;
		bottom: 0;
		visibility: hidden;
		height: 100%;
		right: 0;
		cursor: w-resize;
		align-items: center;
	}
	.wx-event-calendar-event:hover .wx-event-calendar-resizer {
		visibility: visible;
	}
	.wx-event-calendar-selected {
		box-shadow: var(--wx-popup-shadow);
	}

</style>
